 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"DashboardMain~MainHome~appointmentAnotherBook~appointmentBook~myNgoAndSupport~ngoWorkspace~onlineThe~c857d227":"DashboardMain~MainHome~appointmentAnotherBook~appointmentBook~myNgoAndSupport~ngoWorkspace~onlineThe~c857d227","NGOs~appointmentBook~appointmentList~doctorsList~onlineTherapy~onlineTherapyDoctors~supportGroup":"NGOs~appointmentBook~appointmentList~doctorsList~onlineTherapy~onlineTherapyDoctors~supportGroup","DashboardMain~appointmentBook~healthRecords":"DashboardMain~appointmentBook~healthRecords","appointmentBook":"appointmentBook","appointmentAnotherBook~appointmentList~ngoWorkspace~onlineTherapy~onlineTherapyAppointment~sgWorkspace":"appointmentAnotherBook~appointmentList~ngoWorkspace~onlineTherapy~onlineTherapyAppointment~sgWorkspace","appointmentAnotherBook":"appointmentAnotherBook","onlineTherapyAppointment":"onlineTherapyAppointment","healthRecords":"healthRecords","Dashboard~DashboardMain~MainHome~NGOs~OneToOnePeerLeftRoom~UserLeftRoomInConference~aboutUs~appointm~c1b55ee8":"Dashboard~DashboardMain~MainHome~NGOs~OneToOnePeerLeftRoom~UserLeftRoomInConference~aboutUs~appointm~c1b55ee8","Dashboard":"Dashboard","DashboardMain~filestack~myNgoAndSupport~ngoWorkspace~pdfjs-dist~sgWorkspace":"DashboardMain~filestack~myNgoAndSupport~ngoWorkspace~pdfjs-dist~sgWorkspace","DashboardMain":"DashboardMain","myNgoAndSupport":"myNgoAndSupport","MainHome":"MainHome","ngoWorkspace":"ngoWorkspace","sgWorkspace":"sgWorkspace","NGOs":"NGOs","doctorsList~onlineTherapyDoctors":"doctorsList~onlineTherapyDoctors","doctorsList":"doctorsList","onlineTherapyDoctors":"onlineTherapyDoctors","supportGroup":"supportGroup","OneToOnePeerLeftRoom":"OneToOnePeerLeftRoom","UserLeftRoomInConference":"UserLeftRoomInConference","aboutUs":"aboutUs","appointmentDetail~appointmentList~doctorRatingList":"appointmentDetail~appointmentList~doctorRatingList","appointmentDetail~paymentHistory":"appointmentDetail~paymentHistory","appointmentDetail":"appointmentDetail","paymentHistory":"paymentHistory","conference":"conference","contactUs":"contactUs","launchConferenceInfo":"launchConferenceInfo","privacyPolicy":"privacyPolicy","publicNgoList":"publicNgoList","userAgreement":"userAgreement","videoCallOneToOnePeer":"videoCallOneToOnePeer","appointmentList":"appointmentList","onlineTherapy":"onlineTherapy","doctorRatingList":"doctorRatingList","doctorsInfoById":"doctorsInfoById","forgotPw":"forgotPw","myDoctors":"myDoctors","myFeedbacks":"myFeedbacks","myNotifications":"myNotifications","ngoInfoPageById":"ngoInfoPageById","onlineDoctors":"onlineDoctors","paymentCheckout":"paymentCheckout","paymentFailed":"paymentFailed","paymentSuccess":"paymentSuccess","prescriptionList":"prescriptionList","profileUpdate":"profileUpdate","publicNgoInfo":"publicNgoInfo","publicPrescription":"publicPrescription","supportGroupInfoPageById":"supportGroupInfoPageById","filestack":"filestack","pdfjs-dist":"pdfjs-dist","pdfjsWorker":"pdfjsWorker"}[chunkId]||chunkId) + "." + {"DashboardMain~MainHome~appointmentAnotherBook~appointmentBook~myNgoAndSupport~ngoWorkspace~onlineThe~c857d227":"2ec15488","NGOs~appointmentBook~appointmentList~doctorsList~onlineTherapy~onlineTherapyDoctors~supportGroup":"7a80fef1","DashboardMain~appointmentBook~healthRecords":"1dc637be","appointmentBook":"24353952","appointmentAnotherBook~appointmentList~ngoWorkspace~onlineTherapy~onlineTherapyAppointment~sgWorkspace":"e2bb2618","appointmentAnotherBook":"670dbe90","onlineTherapyAppointment":"bf6f0b52","healthRecords":"dd077d1d","Dashboard~DashboardMain~MainHome~NGOs~OneToOnePeerLeftRoom~UserLeftRoomInConference~aboutUs~appointm~c1b55ee8":"99a7f9b0","Dashboard":"49c6613b","DashboardMain~filestack~myNgoAndSupport~ngoWorkspace~pdfjs-dist~sgWorkspace":"ab05b594","DashboardMain":"a11e2943","myNgoAndSupport":"a5b8ba22","MainHome":"4b69b8ca","ngoWorkspace":"b916b16f","sgWorkspace":"308036a8","NGOs":"7d575491","doctorsList~onlineTherapyDoctors":"2894990d","doctorsList":"4b766c67","onlineTherapyDoctors":"54a405d3","supportGroup":"50376263","OneToOnePeerLeftRoom":"2736a43a","UserLeftRoomInConference":"6f92b584","aboutUs":"4faad291","appointmentDetail~appointmentList~doctorRatingList":"8d49ec22","appointmentDetail~paymentHistory":"17d16374","appointmentDetail":"7e9d1921","paymentHistory":"b1b21767","conference":"0be54776","contactUs":"ad73d916","launchConferenceInfo":"4ba1d28f","privacyPolicy":"42109fad","publicNgoList":"4e3b8f15","userAgreement":"f7fe9cbf","videoCallOneToOnePeer":"fa05b471","appointmentList":"ea0f303a","onlineTherapy":"fa07f54f","doctorRatingList":"6ad82b4f","doctorsInfoById":"047f9d00","forgotPw":"350867d7","myDoctors":"e9bc4f4d","myFeedbacks":"c06cda71","myNotifications":"8d14995f","ngoInfoPageById":"4ed9c0e0","onlineDoctors":"e30299d0","paymentCheckout":"266364a7","paymentFailed":"fa80951d","paymentSuccess":"c4268c1f","prescriptionList":"0adedd56","profileUpdate":"b8e6f60d","publicNgoInfo":"99df942f","publicPrescription":"77cd4ed4","supportGroupInfoPageById":"78c75f46","filestack":"fad470d3","pdfjs-dist":"e34d1216","pdfjsWorker":"dd4ec650"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"DashboardMain~appointmentBook~healthRecords":1,"appointmentBook":1,"appointmentAnotherBook~appointmentList~ngoWorkspace~onlineTherapy~onlineTherapyAppointment~sgWorkspace":1,"appointmentAnotherBook":1,"onlineTherapyAppointment":1,"healthRecords":1,"Dashboard":1,"DashboardMain":1,"myNgoAndSupport":1,"MainHome":1,"ngoWorkspace":1,"sgWorkspace":1,"NGOs":1,"doctorsList~onlineTherapyDoctors":1,"doctorsList":1,"onlineTherapyDoctors":1,"supportGroup":1,"OneToOnePeerLeftRoom":1,"UserLeftRoomInConference":1,"aboutUs":1,"appointmentDetail~paymentHistory":1,"appointmentDetail":1,"paymentHistory":1,"conference":1,"contactUs":1,"launchConferenceInfo":1,"privacyPolicy":1,"publicNgoList":1,"userAgreement":1,"videoCallOneToOnePeer":1,"appointmentList":1,"onlineTherapy":1,"doctorRatingList":1,"doctorsInfoById":1,"forgotPw":1,"myDoctors":1,"myFeedbacks":1,"myNotifications":1,"ngoInfoPageById":1,"onlineDoctors":1,"paymentCheckout":1,"paymentFailed":1,"paymentSuccess":1,"prescriptionList":1,"profileUpdate":1,"publicNgoInfo":1,"publicPrescription":1,"supportGroupInfoPageById":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"DashboardMain~MainHome~appointmentAnotherBook~appointmentBook~myNgoAndSupport~ngoWorkspace~onlineThe~c857d227":"DashboardMain~MainHome~appointmentAnotherBook~appointmentBook~myNgoAndSupport~ngoWorkspace~onlineThe~c857d227","NGOs~appointmentBook~appointmentList~doctorsList~onlineTherapy~onlineTherapyDoctors~supportGroup":"NGOs~appointmentBook~appointmentList~doctorsList~onlineTherapy~onlineTherapyDoctors~supportGroup","DashboardMain~appointmentBook~healthRecords":"DashboardMain~appointmentBook~healthRecords","appointmentBook":"appointmentBook","appointmentAnotherBook~appointmentList~ngoWorkspace~onlineTherapy~onlineTherapyAppointment~sgWorkspace":"appointmentAnotherBook~appointmentList~ngoWorkspace~onlineTherapy~onlineTherapyAppointment~sgWorkspace","appointmentAnotherBook":"appointmentAnotherBook","onlineTherapyAppointment":"onlineTherapyAppointment","healthRecords":"healthRecords","Dashboard~DashboardMain~MainHome~NGOs~OneToOnePeerLeftRoom~UserLeftRoomInConference~aboutUs~appointm~c1b55ee8":"Dashboard~DashboardMain~MainHome~NGOs~OneToOnePeerLeftRoom~UserLeftRoomInConference~aboutUs~appointm~c1b55ee8","Dashboard":"Dashboard","DashboardMain~filestack~myNgoAndSupport~ngoWorkspace~pdfjs-dist~sgWorkspace":"DashboardMain~filestack~myNgoAndSupport~ngoWorkspace~pdfjs-dist~sgWorkspace","DashboardMain":"DashboardMain","myNgoAndSupport":"myNgoAndSupport","MainHome":"MainHome","ngoWorkspace":"ngoWorkspace","sgWorkspace":"sgWorkspace","NGOs":"NGOs","doctorsList~onlineTherapyDoctors":"doctorsList~onlineTherapyDoctors","doctorsList":"doctorsList","onlineTherapyDoctors":"onlineTherapyDoctors","supportGroup":"supportGroup","OneToOnePeerLeftRoom":"OneToOnePeerLeftRoom","UserLeftRoomInConference":"UserLeftRoomInConference","aboutUs":"aboutUs","appointmentDetail~appointmentList~doctorRatingList":"appointmentDetail~appointmentList~doctorRatingList","appointmentDetail~paymentHistory":"appointmentDetail~paymentHistory","appointmentDetail":"appointmentDetail","paymentHistory":"paymentHistory","conference":"conference","contactUs":"contactUs","launchConferenceInfo":"launchConferenceInfo","privacyPolicy":"privacyPolicy","publicNgoList":"publicNgoList","userAgreement":"userAgreement","videoCallOneToOnePeer":"videoCallOneToOnePeer","appointmentList":"appointmentList","onlineTherapy":"onlineTherapy","doctorRatingList":"doctorRatingList","doctorsInfoById":"doctorsInfoById","forgotPw":"forgotPw","myDoctors":"myDoctors","myFeedbacks":"myFeedbacks","myNotifications":"myNotifications","ngoInfoPageById":"ngoInfoPageById","onlineDoctors":"onlineDoctors","paymentCheckout":"paymentCheckout","paymentFailed":"paymentFailed","paymentSuccess":"paymentSuccess","prescriptionList":"prescriptionList","profileUpdate":"profileUpdate","publicNgoInfo":"publicNgoInfo","publicPrescription":"publicPrescription","supportGroupInfoPageById":"supportGroupInfoPageById","filestack":"filestack","pdfjs-dist":"pdfjs-dist","pdfjsWorker":"pdfjsWorker"}[chunkId]||chunkId) + "." + {"DashboardMain~MainHome~appointmentAnotherBook~appointmentBook~myNgoAndSupport~ngoWorkspace~onlineThe~c857d227":"31d6cfe0","NGOs~appointmentBook~appointmentList~doctorsList~onlineTherapy~onlineTherapyDoctors~supportGroup":"31d6cfe0","DashboardMain~appointmentBook~healthRecords":"7891d795","appointmentBook":"8a0c609d","appointmentAnotherBook~appointmentList~ngoWorkspace~onlineTherapy~onlineTherapyAppointment~sgWorkspace":"e5419b3b","appointmentAnotherBook":"6a0f45f9","onlineTherapyAppointment":"e8a1cb60","healthRecords":"692ae26f","Dashboard~DashboardMain~MainHome~NGOs~OneToOnePeerLeftRoom~UserLeftRoomInConference~aboutUs~appointm~c1b55ee8":"31d6cfe0","Dashboard":"d5418e01","DashboardMain~filestack~myNgoAndSupport~ngoWorkspace~pdfjs-dist~sgWorkspace":"31d6cfe0","DashboardMain":"98960dfb","myNgoAndSupport":"a229b6ff","MainHome":"3218fbd6","ngoWorkspace":"49afb801","sgWorkspace":"e446efe6","NGOs":"c333b7a3","doctorsList~onlineTherapyDoctors":"f793e895","doctorsList":"7cb6e8f2","onlineTherapyDoctors":"912a1952","supportGroup":"af12937e","OneToOnePeerLeftRoom":"f17afad1","UserLeftRoomInConference":"88e3b889","aboutUs":"35139270","appointmentDetail~appointmentList~doctorRatingList":"31d6cfe0","appointmentDetail~paymentHistory":"49f1edb9","appointmentDetail":"cbe47b28","paymentHistory":"d9224d90","conference":"4a4b16d2","contactUs":"fab8b096","launchConferenceInfo":"66694abc","privacyPolicy":"015b8768","publicNgoList":"667ad6b3","userAgreement":"3b94fd7b","videoCallOneToOnePeer":"96a53ab3","appointmentList":"ce076057","onlineTherapy":"43dd7ae6","doctorRatingList":"e44f6619","doctorsInfoById":"4a1580e3","forgotPw":"0cfad9a3","myDoctors":"a31bf3bc","myFeedbacks":"0c41cdc9","myNotifications":"bc36ae1c","ngoInfoPageById":"698fdef8","onlineDoctors":"cb5f19f9","paymentCheckout":"24e1ea41","paymentFailed":"f3cb341e","paymentSuccess":"4950fd73","prescriptionList":"d4174104","profileUpdate":"310355f3","publicNgoInfo":"4558983e","publicPrescription":"ab53f7bd","supportGroupInfoPageById":"f2308f13","filestack":"31d6cfe0","pdfjs-dist":"31d6cfe0","pdfjsWorker":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
